<template>
  <b-card class="codigo-qr border p-0">
    <div v-if="loading && loading_users" class="mt-5 pb-3 text-center">
      <b-spinner variant="primary"></b-spinner>
      <h5 class="mt-3">
        Es necesario permiso a la cámara <br />
        y que terminen de cargar los usuarios
      </h5>
    </div>
    <!--   <div v-if="display" :class="loading ? 'd-none' : 'h-100'">
      <h3 v-if="error != ''" class="error mt-5 text-center">
        <span class="h1 error">ERROR!</span>
        <br />
        <br />
        {{ error }}
      </h3>

      <div class="pt-0 h-100" v-else>
        <h2
          data-v-0061e6c5
          class="text-center h1 mb-5"
          style="font-size: 20px !important;z-index: 1;position: absolute;top: 15px;background: gray;left: 50%;transform: translate(-50%, -50%);color: white;width: 100%;padding-top: 5px;padding-bottom: 5px;"
        >Toma de asistencia</h2>
        <qrcode-stream class="h-100" @decode="onDecode" @init="onInit"></qrcode-stream>
      </div>
    </div> -->

    <b-form class="w-50 mx-auto mt-3">
      <b-form-group>
        <label for="" class="text-center">Seleccionar método de Lectura</label>
        <b-form-select
          :options="['FIJO','MÓVIL']"
          v-model="tipo_lectura"
        ></b-form-select>
      </b-form-group>
    </b-form>

    <StreamBarcodeReader
      v-if="display && !loading_users && tipo_lectura==='MÓVIL'"
      @decode="onDecode"
      @loaded="onLoaded"
    ></StreamBarcodeReader>
    
    <div style="position:relative;" v-else-if="display && !loading_users && tipo_lectura==='FIJO'">
      <div style="" class="w-100 bg-danger"></div>
      <b-form-input style=""  :disabled="false" autofocus class=" mb-5 w-50 mx-auto" @keypress.enter="showUser($event)" type="text" ></b-form-input>

    </div>
    <div
      class="d-flex h-100 align-items-center w-100"
      v-else-if="!loading_users"
    >
      <div class="w-100">
        <b-img fluid rounded class="w-100 mb-5" :src="url + user.foto" />

        <b-list-group class="w-100 my-3">
          
          <b-list-group-item>
            <strong>Fecha y hora:</strong>
            {{ getDateTime() }}
          </b-list-group-item>

          <b-list-group-item>
            <strong>Nombre:</strong>
            {{ user.nombre_full }}
          </b-list-group-item>
          <!-- <b-list-group-item >
               <strong>Area:</strong>  {{ user.usu_area.descripcion }}
          </b-list-group-item>-->
          <b-list-group-item>
            <strong>Grupo:</strong>
            {{
              user.usu_grupo != null ? user.usu_grupo.descripcion : "Sin grupo"
            }}
          </b-list-group-item>
          <b-list-group-item>
            <strong>Puesto:</strong>
            {{
              user.usu_puesto != null
                ? user.usu_puesto.descripcion
                : "Sin puesto"
            }}
          </b-list-group-item>
        </b-list-group>

        <b-button-group class="w-100 mt-5">
          <b-button @click="reset()" variant="danger">Cancelar</b-button>
          <b-button
            variant="success"
            @click="
              cancel = false;
              checarAsistencia();
            "
            >Aceptar</b-button
          >
        </b-button-group>
      </div>
    </div>
  </b-card>
</template>

<script>
/* eslint-disable */
//import { QrcodeStream } from "vue-qrcode-reader";
import { mapState } from "vuex";
import ApiService from "@/core/services/api.service";
import { StreamBarcodeReader } from "vue-barcode-reader";
import Swal from "sweetalert2";

export default {
  components: {
    // QrcodeStream,
    StreamBarcodeReader
  },
  data: () => ({
    result: "",
    error: "",
    loading: true,
    display: true,
    user: null,
    cancel: false,
    tipo_lectura:'MÓVIL',
  }),
  computed: {
    ...mapState({
      users: state => state.users.users,
      loading_users: state => state.users.loading,
      getAsistencias: state => state.asistencias.asistencias
    }),
    url() {
      let url = "";
      const hostname = window.location.hostname;
      if (hostname.includes("localhost") || hostname.includes("127.0.0.1")) {
        url = "https://res.appagricactus.com/uploads/";
      } else {
        url = "https://res.appagricactus.com/uploads/";
      }
      return url;
    },
    user_id() {
      if (this.user != null) {
        return this.user.id;
      }
      return null;
    }
  },
  watch: {
    user_id(nV) {
      const self = this;
      setTimeout(function() {
        if (nV != null && !this.cancel) {
          self.checarAsistencia();
        } else {
          self.cancel = false;
        }
      }, 2000);
    }
    /* isOnline(nV) {
      if (nV) {
        console.log("online");
      } else {
        console.log("offline");
      }
    }, */
  },
  methods: {
    showUser(e){
      let usuarioId = e.target.value;
      this.onDecode(usuarioId);
    },
    onLoaded() {
      this.loading = false;
    },
    onDecode(decodedString) {
      let user = this.users.find(x => x.id === parseInt(decodedString));
      this.user = user;
      if (user != undefined) {
        this.display = false;
      } else {
        this.$toasted.show("No se encuentra el usuario.", {
          duration: 1500,
          type: "error"
        });
      }
    },
    getDateTime() {
      const d = new Date();
      return (
        d
          .toJSON()
          .slice(0, 10)
          .replace(/-/g, "-") +
        " " +
        d.toLocaleTimeString()
      );
    },
    checarAsistencia() {
      if (this.cancel) {
        return false;
      }

      this.cancel = true;
      this.$store.dispatch("getJornadaId").then(jornadaId => {
        this.$store.dispatch("getActividadId").then(actividadId => {
          this.$store.dispatch("getAreaId").then(areaId => {
            if ((jornadaId && areaId && actividadId) != 0) {
              //begin:: checar asistenacia
              ApiService.post("asistencia", {
                usuarioId: this.user.id,
                jornadaId,
                cuadroId: areaId,
                actividadId,
                date: this.getDateTime()
              })
                .then((res) => {
                  if(res.data.success===false){
                    Swal.fire({
                      title: "Error",
                      text: res.data.message,
                      icon: "error",
                      confirmButtonClass: "btn btn-secondary"
                    });
                    return;
                  }
                  const date = this.getDateTime()
                  this.$store.dispatch("putAsistencia", {
                    user_id: this.user.id,
                    jornadaId,
                    date,
                    actividadId,
                    cuadroId: areaId
                  });
                  this.$toasted.show("Se registro asistencia con éxito", {
                    duration: 1500,
                    type: "success"
                  });
                  this.reset();
                  this.cancel = false;
                })
                .catch(({ response }) => {
                  if (response === undefined) {
                    this.$toasted.show("Se registro asistencia con éxito", {
                      duration: 1500,
                      type: "success"
                    });
                    this.reset();
                  }
                });
              //end:: checar asistenacia
            } else {
              this.$toasted.show(
                "Debes seleccionar el actividad, cuadro y jornada",
                {
                  duration: 1500,
                  type: "error"
                }
              );
            }
          });
        });
      });
    },
    reset() {
      this.user = null;
      this.display = true;
      this.cancel = true;
    },
    async onInit(promise) {
      this.loading = true;
      try {
        await promise;
      } catch (error) {
        if (error.name === "NotAllowedError") {
          this.error = "Necesitas dar permiso a la cámara para funcionar.";
        } else if (error.name === "NotFoundError") {
          this.error = "Este dispositivo no cuenta con cámara";
        } else if (error.name === "NotSupportedError") {
          this.error = "Seguridad necesaria (HTTPS, localhost)";
        } else if (error.name === "NotReadableError") {
          this.error = "La cámara está lista para ser usada?";
        } else if (error.name === "OverconstrainedError") {
          this.error = "Su cámara no es apta para está modalidad.";
        } else if (error.name === "StreamApiNotSupportedError") {
          this.error = "Stream API no es soportado por este dispositivo.";
        }
      } finally {
        this.loading = false;
      }
    }
  },
  created() {
    /* this.$store.dispatch("putAsistencia", {
      user_id: 1,
      jornada_id: 1,
      date: new Date().toJSON().slice(0, 10).replace(/-/g, "/"),
    }) */
  },
  mounted() {}
};
</script>

<style scoped>
.error {
  font-weight: bold;
  color: red;
}
.codigo-qr .wrapper {
  padding-top: 0;
}
.codigo-qr .card-body {
  padding: 0;
}
.codigo-qr .wrapper video {
  border-radius: 0.42rem !important;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
